import { RoleClient } from './RoleClient';
import HttpClient from '../../gateway/HttpClient';
import { notUndefined } from '../../util/Assert';
import { Role } from '../../domain/rbac/RbacDomains';
import HttpMethod from '../../constant/HttpMethod';
import { RoleMethods } from '../../constant/MethodNames';
import { query } from '@trlogic/client-js';
import Query = query.Query;

class NestRoleClient implements RoleClient {
  private httpClient: HttpClient;

  constructor(httpClient: HttpClient) {
    notUndefined(httpClient, 'Http client cannot be undefined');
    this.httpClient = httpClient;
  }

  public delete(id: string): Promise<void> {
    return this.httpClient.execute(HttpMethod.DELETE, `${RoleMethods.REMOVE}/${id}`);
  }

  public exist(id: string): Promise<boolean> {
    return this.httpClient.execute<boolean>(HttpMethod.GET, `${RoleMethods.EXIST}`, {}, { id: id });
  }

  public getCount(query: Query): Promise<number> {
    return this.httpClient.execute(HttpMethod.GET, `${RoleMethods.COUNT}`, undefined, { query });
  }

  public save(id: string, role: Role): Promise<void> {
    const dto = { id, role };
    return this.httpClient.execute(HttpMethod.POST, `${RoleMethods.SAVE}`, dto);
  }

  public getRoleNames(): Promise<string[]> {
    return this.httpClient.execute(HttpMethod.GET, RoleMethods.GET_NAMES);
  }
}

export default NestRoleClient;
